<template>
  <div id="taxGroup">
    <div class="container">

      <PageTitle :title="`${$t('tax_group.title')} ${data.uniqueName || ''}`"></PageTitle>

      <Panel :title="$t('tax_group.information')" collapsible>
        <div class="group">
          <label>{{ $t('tax_group.uniqueName') }}</label>
          <input type="text" v-model="data.uniqueName">
        </div>
        <div class="group">
          <label>{{ $t('tax_group.taxes') }}</label>
          <MultiSelect :options="multiSelect.options" :selected="multiSelect.selected" :trackByAttribute="'value'"
            @changed="multiSelect.selected = $event" />
        </div>
      </Panel>

      <div class="footer-actions">
        <button class="save btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import MultiSelect from '@/components/tools/MultiSelect.vue';
  import { mapActions } from 'vuex';
  import PageTitle from "@/components/PageTitle";

  export default {
    name: "TaxGroup",

    components: { MultiSelect, PageTitle },

    data() {
      return {
        allTaxes: [],
        multiSelect: {
          options: [],
          selected: []
        },
        data: {
          uniqueName: null,
          taxes: []
        }
      }
    },

    watch: {
      'multiSelect.selected'(newVal) {
        this.data.taxes = newVal.map(v => ({ id: v.value }))
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "tax_group.title";
      this.$store.state.pageIcon = "";

      this.$store.commit("showSpinner", true);
      let taxes = await this.getTaxes();
      this.$store.commit("showSpinner", false);

      if (taxes) {
        this.multiSelect.options = taxes.data.map(t => ({
          value: t.id,
          label: t.name
        }))
      }

      let id = this.$route.query.id;
      if (id) {
        this.$store.commit("showSpinner", true);
        let taxGroup = await this.getTaxGroup({ taxGroupId: id });
        this.$store.commit("showSpinner", false);
        if (taxGroup) {
          Object.assign(this.data, taxGroup);
          this.multiSelect.selected = this.data.taxes.map(t => ({
            value: t.id,
            label: t.name
          }))
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      }
    },

    methods: {
      ...mapActions(['getTaxGroup', 'saveTaxGroup', 'getTaxes']),

      async save() {
        this.$store.commit("showSpinner", true);
        let taxGroup = await this.saveTaxGroup({ data: this.data });
        this.$store.commit("showSpinner", false);

        if (taxGroup) {
          toast(this.$t('save'), 'success');
          this.$router.push(this.$router.buildContext("/tax-groups"));
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      }
    }
  }
</script>